import React from 'react';
import { noDealsvg } from '../../../Routes/DealsAndDiscounts/Components/ProductListing/svg';

const ZeroState = ({ type }) => {
    const content = {
        deals: {
            title: 'Oops!',
            message: 'No deals found.',
            subMessage:
                'We are busy curating exciting offers for you. Stay tuned.',
            icon: noDealsvg
        },
        events: {
            title: 'Sorry!',
            message: 'No images or videos are present for this event.',
            subMessage: 'We will update soon.',
            icon: noDealsvg
        },
        blogs: {
            title: 'Sorry!',
            message: 'No blogs found.',
            subMessage:
                'We are busy curating exciting content for you. Stay tuned.',
            icon: noDealsvg
        }
    };

    const { title, message, subMessage, icon } = content[type];

    return (
        <div className="mt-4 px-4 lg:px-0">
            <div className="w-full pl-0 xl:pl-6 mt-4 border border-gray-300 rounded-xl">
                <div className="flex flex-row items-center justify-center p-5 lg:p-7 gap-5">
                    <div className="mt-1 lg:mt-0">{icon}</div>
                    <div className="flex flex-col">
                        <p className="text-lg lg:text-2xl font-bold">{title}</p>
                        <p className="text-sm lg:text-base whitespace-nowrap mt-2">{message}</p>
                        <p className="lg:whitespace-nowrap mt-1 text-gray-400">
                            {subMessage}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ZeroState;
